const defaultRouterBasePath = '/';

const defaultNotifierType = 'none'; // can be "polling", "socket", or "any thing else to disable"
const defaultPollingInterval = 30000; // time between polling requests in ms if notifierType is "polling"


const defaultApiHost = '';
const defaultApiBasePath = '/api/v1';
const defaultSocketPath = '/stream/v1';
const defaultSocketBaseChannel = 'api::v1';
const defaultSocketDelimiter = '::';

const defaultAuthHost = '';
const defaultAuthType = 'http';
const defaultAuthJWTLoginPath = '/accounts/jwt/login';
const defaultAuthJWTRefreshPath = '/accounts/jwt/refresh';
const defaultAuthHTTPLoginPath = '/accounts/http/login';

const defaultGlobalConfigKey = '__config';

const configKeys = [
  'routerBasePath', 'notifierType', 'pollingInterval', 'apiHost', 'apiBasePath', 'socketPath', 'socketBaseChannel',
  'authHost', 'authType', 'authJWTLoginPath', 'authJWTRefreshPath', 'authHTTPLoginPath', 'logoUrl'
];

class Config {

  constructor(globalConfigKey = defaultGlobalConfigKey) {
    this._routerBasePath = defaultRouterBasePath;
    this._notifierType = defaultNotifierType;
    this._pollingInterval = defaultPollingInterval;
    this._apiHost = defaultApiHost;
    this._apiBasePath = defaultApiBasePath;
    this._socketPath = defaultSocketPath;
    this._socketBaseChannel = defaultSocketBaseChannel;
    this._socketDelimiter = defaultSocketDelimiter;
    this._authHost = defaultAuthHost;
    this._authType = defaultAuthType;
    this._authJWTLoginPath = defaultAuthJWTLoginPath;
    this._authJWTRefreshPath = defaultAuthJWTRefreshPath;
    this._authHTTPLoginPath = defaultAuthHTTPLoginPath;
    this._logoUrl = null;

    if (window[globalConfigKey] !== undefined) {
      let config = window[globalConfigKey];
      for (let configKey of configKeys) {
        if (config[configKey] !== undefined) {
          this['_' + configKey] = config[configKey];
        }
      }
    }
  }

  getRouterBasePath() {
    return this._routerBasePath;
  }

  getNotifierType() {
    return this._notifierType;
  }

  getPollingInterval() {
    return this._pollingInterval;
  }

  getApiHost() {
    return this._apiHost;
  }

  getApiBasePath() {
    return this._apiBasePath;
  }

  getApiBaseUrl() {
    return this._apiHost + this._apiBasePath;
  }

  getSocketPath() {
    return this._socketPath;
  }

  getSocketBaseChannel() {
    return this._socketBaseChannel;
  }

  getSocketDelimiter() {
    return this._socketDelimiter;
  }

  getAuthHost() {
    return this._authHost;
  }

  getAuthType() {
    return this._authType;
  }

  isAuthTypeJWT() {
    return this._authType === 'jwt';
  }

  isAuthTypeHTTP() {
    return this._authType === 'http';
  }

  getAuthJWTLoginPath() {
    return this._authJWTLoginPath;
  }

  getAuthJWTLoginUrl() {
    return this._authHost + this._authJWTLoginPath;
  }

  getAuthJWTRefreshPath() {
    return this._authJWTRefreshPath;
  }

  getAuthJWTRefreshUrl() {
    return this._authHost + this._authJWTRefreshPath;
  }

  getAuthHTTPLoginPath() {
    return this._authHTTPLoginPath;
  }

  getAuthHTTPLoginUrl() {
    return this._authHost + this._authHTTPLoginPath;
  }

  getLogoUrl() {
    return this._logoUrl;
  }
}

export const config = new Config();